import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { type EditorAgent } from '@atlassian/generative-ai-modal/utils/agents';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';

import {
	createInsertAtCurrentPosition,
	createInsertBelow,
	createReplace,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactoryOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

type Options = EditorPluginAIConfigItemFactoryOptions & {
	agent: EditorAgent;
};
export const createFreeGenerateEditorAgentConfigItem: (
	options: Options,
) => EditorPluginAIConfigItem = (options) => ({
	key: CONFIG_ITEM_KEYS.FREE_GENERATE_EDITOR_AGENT,
	title: sharedMessages.aiButtonTitle,
	description: sharedMessages.aiUniversalLongCallToAction,
	promptHint: aiConfigItemMessages.freeGeneratePromptHint,
	icon: () => <AtlassianIntelligenceIcon label="" spacing="spacious" />,
	doNotHighlightDocWhenSelectionIsEmpty: true,
	insertOnEmptySelection: true,
	quickInsertPriority: Number.NEGATIVE_INFINITY,
	canTogglePageKnowledge: false,
	disableInterrogation: () => false,
	silentAgentPrompt: true,
	agent: options.agent,
	intentSchemaId: 'DISABLED',
	actions: {
		empty: [createInsertAtCurrentPosition({ appearance: 'primary' })],
		selection: [
			createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => 'assistance-service',
});
